export type AddressSituation = 'HOMEOWNER' | 'PRIVATETENANT' | 'COUNCILTENANT' | 'LIVINGWITHPARENTS' | 'LIVINGWITHPARTNER' | 'UNKNOWN'

export const mapToAddressSituation = (addressSituation: string): AddressSituation => {
  switch (addressSituation.toLowerCase()) {
    case 'homeowner':
      return 'HOMEOWNER'
    case 'private tenant':
      return 'PRIVATETENANT'
    case 'council tenant':
      return 'COUNCILTENANT'
    case 'living with parents':
      return 'LIVINGWITHPARENTS'
    case 'living with partner':
      return 'LIVINGWITHPARTNER'
    default:
      return 'UNKNOWN'
  }
}
